import React from "react";
import { Modal, Button } from "antd";
import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

interface ExclamationErroModalProps {
  isVisible: boolean;
  errorMessage: string;
  onContinue: () => void;
}

const ExclamationErroModal: React.FC<ExclamationErroModalProps> = ({
  isVisible,
  errorMessage,
  onContinue,
}) => {
  return (
    <Modal
      //   title={
      // <div style={{ display: 'flex', alignItems: 'center', color: '#ff4d4f' }}>
      //   <span>Error</span>
      // </div>

      //   }
      open={isVisible}
      footer={[
        <Button
          key="continue"
          type="primary"
          onClick={onContinue}
          //   style={{ backgroundColor: "#ff4d4f", borderColor: "#ff4d4f" }}
          style={{ marginTop: "0" }}
        >
          Continue
        </Button>,
      ]}
      onCancel={onContinue}
      centered
      maskClosable={false}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          color: "#ff4d4f",
          justifyContent: "center",
        }}
      >
        <ExclamationCircleOutlined style={{ fontSize: "70px" }} />
      </div>
      <div style={{ padding: "20px 0", fontSize: "16px" }}>{errorMessage}</div>
    </Modal>
  );
};

export default ExclamationErroModal;
